export function carregarEstilosGlobais() {
  // O Edge exibe um ícone nativo de exibir senha nos campos de senha, que
  // ficaria duplicado com o botão de exibir senha do sistema
  const css = 'input::-ms-reveal { display: none; }';

  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = css;

  document.head.appendChild(style);
}
